import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetowaicabservice() {



  const cardData = {
"keyword": "Pune to Wai Cab Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Wai Cab Service for travelers seeking a safe, affordable, and convenient short-distance journey to one of Maharashtra’s most scenic and culturally rich towns. Whether you are planning a family trip, photography tour, weekend getaway, temple visit, or nature excursion, our taxi service ensures a smooth and stress-free travel experience. With experienced drivers who are well-versed with highway and ghat routes, clean air-conditioned vehicles maintained for comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Wai. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible half-day and full-day packages, doorstep pickup from Pune, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and enjoyable journey to Wai and nearby attractions.",

"topPlaces": [
  {
    "title": "Dhom Dam",
    "description":
      "Dhom Dam is a scenic water reservoir near Wai known for its calm waters, boating activities, and beautiful views of the Sahyadri hills, making it a popular picnic and photography spot."
  },
  {
    "title": "Wai Temples (Ghats of Krishna River)",
    "description":
      "Wai is famous for its ancient temples along the Krishna River ghats, showcasing traditional Maratha architecture and spiritual significance, often used for cultural rituals and film shoots."
  },
  {
    "title": "Menavali Village",
    "description":
      "Menavali is a historic village near Wai known for Nana Phadnavis Wada, traditional temples, and scenic riverside landscapes that reflect Maharashtra’s heritage."
  },
  {
    "title": "Dholya Ganpati Temple",
    "description":
      "Dholya Ganpati Temple is a famous Ganesh temple located on the Krishna riverbank in Wai, known for its peaceful atmosphere and historical importance."
  },
  {
    "title": "Pandavgad Fort",
    "description":
      "Pandavgad Fort near Wai is a hill fort offering trekking opportunities, ancient ruins, and panoramic views of the surrounding valleys and Sahyadri ranges."
  },
  {
    "title": "Wai Film Shooting Locations",
    "description":
      "Wai is known as a popular film shooting destination in Maharashtra, with many Bollywood and Marathi movies filmed along its river ghats, temples, and traditional streets."
  },
  {
    "title": "Bhor Ghat Extension Route",
    "description":
      "The Pune to Wai route passes through scenic sections of the Sahyadri ranges and nearby ghats, offering a short but beautiful journey filled with greenery and hills."
  },
  {
    "title": "Krishna River Ghats",
    "description":
      "The Krishna River ghats in Wai are known for their peaceful environment, religious importance, and scenic beauty, attracting both pilgrims and tourists."
  },
  {
    "title": "Kamalgad Fort (Nearby)",
    "description":
      "Kamalgad Fort near Wai is a lesser-known trekking destination surrounded by forests and hills, ideal for adventure lovers and nature explorers."
  },
  {
    "title": "Wai Heritage Town",
    "description":
      "Wai is a historic town in Satara district known for its temples, ghats, cultural heritage, and natural beauty, making it a popular short trip destination from Pune."
  }
],



services: [
  {
    name: "Pune to Wai Cab",
    description: "Pune to Wai cab service provides reliable transportation for passengers traveling between Pune and Wai with comfortable vehicles and experienced drivers. Vehicles are suitable for highway and hill-route travel ensuring smooth and timely journeys for families, tourists, weekend travelers, and local passengers. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient Pune to Wai cab reservations."
  },
  {
    name: "Pune to Wai Taxi",
    description: "Pune to Wai taxi service offers dependable transportation for outstation and hill station travel with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for family trips, tourism, weekend outings, and intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Pune to Wai taxi reservations."
  },
  {
    name: "Cab from Pune to Wai",
    description: "Cab from Pune to Wai service provides comfortable transportation for passengers traveling from Pune to Wai and nearby destinations. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth travel journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and nearby locations across Pune. Ideal for tourists, families, and weekend travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Wai",
    description: "Taxi from Pune to Wai service offers reliable transportation with comfortable vehicles and professional drivers for passengers requiring direct travel between Pune and Wai. Vehicles provide smooth city and highway travel suitable for tourism, sightseeing, hill station visits, and family travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available directly from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Wai Cab Service",
    description: "Pune to Wai cab service provides dependable transportation solutions for outstation travel between Pune and Wai. Vehicles are suitable for long-distance and ghat-route travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for tourism trips, weekend getaways, sightseeing tours, and family vacations. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Pune to Wai Taxi Fare",
    description: "Pune to Wai taxi fare service provides transparent and reliable transportation options for travelers planning budget-friendly travel between Pune and Wai. Travelers can enjoy smooth journeys with experienced drivers familiar with hill routes and highway conditions. Comfortable vehicles ensure timely travel with safe transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient taxi fare cab reservations."
  },
  {
    name: "Pune to Wai One Way Cab",
    description: "Pune to Wai one way cab service provides economical and comfortable transportation for travelers planning one-side travel between Pune and Wai. Comfortable vehicles ensure smooth highway travel suitable for tourism, weekend outings, and family travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Wai Round Trip Taxi",
    description: "Pune to Wai round trip taxi service offers spacious transportation for families and groups traveling between Pune and Wai with return travel options. Vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for family outings and sightseeing travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient round trip taxi reservations."
  },
  {
    name: "Pune to Wai Cab Booking",
    description: "Pune to Wai cab booking service provides premium transportation for passengers seeking comfortable and reliable outstation travel. Vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, business trips, and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Cheap Pune to Wai Cab",
    description: "Cheap Pune to Wai cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Wai. Vehicles provide smooth highway travel with comfortable seating and luggage space suitable for one-way and round-trip journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Wai Taxi",
    description: "Best Pune to Wai taxi service offers dependable transportation for passengers planning direct outstation travel between Pune and Wai. Comfortable vehicles ensure smooth highway travel suitable for tourism, sightseeing trips, weekend travel, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Wai Cab",
    description: "Sedan Pune to Wai cab service provides reliable transportation for travelers planning comfortable journeys between Pune and Wai. Sedan vehicles ensure smooth and safe travel suitable for tourists, couples, families, and business travelers. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Wai Taxi",
    description: "SUV Pune to Wai taxi service offers comfortable transportation for passengers looking for spacious and reliable travel services between Pune and Wai. SUV vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for hill station tours, family trips, sightseeing travel, and outstation travel requirements. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Wai Cab",
    description: "Innova Pune to Wai cab service provides dependable transportation for passengers planning premium outstation travel between Pune and Wai. Innova vehicles ensure smooth highway travel suitable for tourism, hill station visits, sightseeing tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Hill Station Cab Pune Wai",
    description: "Hill station cab Pune Wai service provides affordable and convenient transportation for passengers traveling between Pune and Wai through scenic hill routes. Vehicles ensure reliable highway travel with experienced drivers offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for tourists, family travelers, sightseeing trips, and weekend getaway travel requirements. Flexible booking options allow convenient hill station cab reservations."
  }
],

tableData: [
  ["Pune to Wai Cab", "Pune to Wai Taxi"],
  ["Cab from Pune to Wai", "Taxi from Pune to Wai"],
  ["Pune to Wai Cab Service", "Pune to Wai Taxi Fare"],
  ["Pune to Wai One Way Cab", "Pune to Wai Round Trip Taxi"],
  ["Pune to Wai Cab Booking", "Cheap Pune to Wai Cab"],
  ["Best Pune to Wai Taxi", "Sedan Pune to Wai Cab"],
  ["SUV Pune to Wai Taxi", "Innova Pune to Wai Cab"],
  ["Hill Station Cab Pune Wai", "Pune to Wai Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Wai Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Wai cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe outstation travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Wai Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Wai cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Wai Cab Availability",
        WhyChoosedescription: "Our Pune to Wai cab service operates 24 hours a day for family travel, temple visits, Mahabaleshwar trips, sightseeing tours, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Wai taxi service, round-trip bookings, sightseeing tours, and customized outstation travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, tourists, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Highway Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Wai highway and ghat routes, ensuring safe driving, smooth travel, and timely arrival for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Wai cab service?", answer: "Pune to Wai cab service provides comfortable taxi transportation between Pune and Wai for family travel, sightseeing tours, and outstation journeys." },
    { question: "Is Pune to Wai cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Wai cab service." },
    { question: "Which vehicles are available for Pune to Wai travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Wai?", answer: "Yes, customers can book one-way as well as round-trip Pune to Wai taxi services." },
    { question: "Do you provide sightseeing taxi packages for Wai and nearby places?", answer: "Yes, Shivai Travels provides Wai sightseeing and customized travel packages for nearby destinations like Panchgani and Mahabaleshwar." },
    { question: "Are all Pune to Wai taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune to Wai cab service online?", answer: "Yes, customers can easily book Pune to Wai cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune to Wai cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Wai cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshmukh",
    feedback:
      "Had a comfortable Pune to Wai cab journey with a well-maintained vehicle and a skilled driver who ensured a smooth and scenic travel experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "The Pune to Wai taxi service was very reliable with timely pickup, clean car, and a relaxed journey making the trip enjoyable and stress-free.",
    rating: 5
  }
];




  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Wai Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-wai-cab.jpg",
  "description": "Book Pune to Wai Cab Service for safe and comfortable hill station travel. Shivai Travels offers reliable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7 for short trips, weekend getaways, and sightseeing.",
  "brand": {
    "@type": "Brand",
    "name": "Shivaitravels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹9/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-wai-cab-service"
  }
};








  return (
    <div>
<Helmet>
  <title>Pune to Wai Cab Service | Hill Station Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Wai cab service for safe and comfortable travel. Affordable one-way and round-trip taxi options with sedan, SUV, Innova, and luxury cabs available 24x7 for hill station trips and sightseeing."
  />

  <meta
    name="keywords"
    content="pune to wai cab, pune to wai taxi, cab from pune to wai, taxi from pune to wai, pune to wai cab service, pune to wai taxi fare, pune to wai one way cab, pune to wai round trip taxi, pune to wai cab booking, cheap pune to wai cab, best pune to wai taxi, sedan pune to wai cab, suv pune to wai taxi, innova pune to wai cab, hill station cab pune wai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/78.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetowaicabservice;